import { css } from "@emotion/css";
import { Link } from "react-router-dom";
import colors from "src/utils/colors";

const HeaderLogo = (props) => (
  <Link
    {...props}
    className={css`
      height: 50px;
      line-height: 50px;
      display: inline-block;
      vertical-align: top;
      max-width: 50%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-decoration: none !important;
      color: ${colors.baseGray};
      &:hover {
        color: ${colors.baseGray};
      }
      & img {
        display: inline;
        cursor: pointer;
      }
    `}
  />
);

export default HeaderLogo;
